import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import aboutImage from '../assets/img/about.png';
import aboutImageDark from '../assets/img/about_dark.png';

const About: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const currentImage = theme === 'dark' ? aboutImageDark : aboutImage;

  return (
    <div className="min-h-screen bg-white dark:bg-[#111111] pt-16 relative overflow-hidden transition-colors duration-300">
      {/* Right side decoration image - desktop only */}
      <div className="hidden lg:block absolute top-8 right-0 w-80 h-85 pointer-events-none">
        <img 
          src={currentImage} 
          alt="About decoration" 
          className="w-full h-full object-contain"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 sm:py-16 lg:py-24 relative z-10">
        {/* Main content */}
        <div className="max-w-4xl">
          {/* Title */}
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 dark:text-gray-100 mb-8 sm:mb-12">
            {t('about.title')}
          </h1>

          {/* Content */}
          <div className="text-gray-700 dark:text-gray-300 leading-relaxed space-y-4 sm:space-y-6">
            <p className="text-sm sm:text-base">
              {t('about.paragraph1')}
            </p>

            <p className="text-sm sm:text-base">
              {t('about.paragraph2')}
            </p>

            <p className="text-sm sm:text-base">
              {t('about.paragraph3')}
            </p>

            {/* Features List */}
            <div className="pl-4 sm:pl-6 space-y-3 sm:space-y-4 my-4 sm:my-6">
              <div>
                <h3 className="text-sm sm:text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">
                  • {t('about.feature1Title')}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 pl-3 sm:pl-4">
                  {t('about.feature1Desc')}
                </p>
              </div>

              <div>
                <h3 className="text-sm sm:text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">
                  • {t('about.feature2Title')}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 pl-3 sm:pl-4">
                  {t('about.feature2Desc')}
                </p>
              </div>

              <div>
                <h3 className="text-sm sm:text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">
                  • {t('about.feature3Title')}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 pl-3 sm:pl-4">
                  {t('about.feature3Desc')}
                </p>
              </div>
            </div>

            <p className="text-sm sm:text-base">
              {t('about.paragraph4')}
            </p>

            <p className="text-sm sm:text-base">
              {t('about.paragraph5')}
            </p>

            <p className="text-sm sm:text-base">
              {t('about.paragraph6')}
            </p>

            <p className="text-sm sm:text-base">
              {t('about.paragraph7')}
            </p>

            <p className="text-sm sm:text-base font-semibold text-gray-900 dark:text-gray-100 mt-6 sm:mt-8">
              {t('about.conclusion')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
